type PromisePrune<T> = T extends Promise<unknown> ? Awaited<T> : T;

export function promiseWithAbortCtrl<F>(promiseOrData: F, signal: AbortSignal) {
  return Promise.resolve(promiseOrData).then(data => {
    signal.throwIfAborted();

    return data as PromisePrune<F>;
  });
}
